import { IPHONE_REGEX } from '../constants/constants';

export default {
	bind: function (el, binding) {
		if (IPHONE_REGEX.test(navigator.userAgent)) {
			el.setAttribute('href', binding.value);
		}
	}
};
